import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";


export const TechnicianList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  // Header
  useEffect(() => {
    updateMainHeader("Administration");
    labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
  }, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Technician Management": "/technician/list" },
  ]);

  const source = {
    url: "technicians/list",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const
  };

  const columns: IColumns[] = [
    { header: "Technician Name", fieldName: "TechnicianName" },
    { header: "Phone", fieldName: "Phone", tooltip: true },
    { header: "Email", fieldName: "Email", tooltip: true },
    { header: "Address", fieldName: "Address", tooltip: true },
    { header: "Skill", fieldName: "Skill", tooltip: true },
    { header: "Active", fieldName: "IsActive" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        const technicianId = row.TechnicianId;
        if (!technicianId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid technician data - missing ID", "error");
          return;
        }

        if (action === "Edit") {
          navigate(`/technician/${technicianId}`);
        } else if (action === "Delete") {
          setSelectedId(technicianId);
          setPopupOpen(true);
        }
      },
    },
  ];

  const handleClick = () => {
    navigate("/technician");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="technicianGrid"
            title="Technician Management"
            headerType="modern"
            columns={columns}
            source={source}
            exportCsv
            rowsPerPageCount={10}
            searchBox={{ fieldName: "TechnicianName" }}
            addButton={{ label: "Add New Technician", color: "secondary" }}
            onAddButtonClick={handleClick}
            multiSelect={true}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>

        <ConfirmationPopup
          type="DELETE"
          apiUrl="technicians"
          id={selectedId}
          confirmMessage="Are you sure you want to delete this technician?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("technicianGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.detail || "Delete failed", "error");
            }
          }}
        />
      </Grid>
    </Grid>
  );
};
